export default __webpack_public_path__ + "static/media/Geneva-Normal-Italic.411b3d2d.ttf";